import apihelper from './apihelper'
import vuet from '@/vuet'
import config from '@/util/config'
import wx from './wx.js'
import bmap from './bmap.js'
import user from './user.js'
import useraddress from './useraddress.js'
import common from './common.js'
import menu from './menu.js'
import order from './order.js'
import app from './app.js'
import workgroup from './workgroup.js'

var apilist = {
  wx: wx,
  bmap: bmap,
  user: user,
  useraddress: useraddress,
  common: common,
  menu: menu,
  order: order,
  app: app,
  workgroup: workgroup
}

export default apilist
